import React from "react";

export default function BtnCheck({id}) {
    return <a className="btn-flat btn-check" req-id={id}>
        <i className="material-icons">check</i>
    </a>
}